import { render } from "./Navbar.vue?vue&type=template&id=5cf9a124"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=5cf9a124&lang=css"

import exportComponent from "/var/www/html/p23_selfpayment_pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__